/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-curly-newline */
import { KeyboardEvent, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { useAuth } from "../../../hooks/auth";
import { carcerarioStoreNominal } from "../../../hooks/store";

import { LayoutConsultaCarcerario } from "./LayoutConsultaCarcerario";
import { ResultadoConsultaCarcerario } from "../../../components";

type InputProps = {
  nome: string | undefined;
  vulgo: string | undefined;
  nomeMae: string | undefined;
  nomePai: string | undefined;
};

export const FiltroCarcerarioNominal: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      nome: "",
      vulgo: "",
      nomeMae: "",
      nomePai: "",
    },
  });

  const { user } = useAuth();
  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 4 ? s.url : false;
  })[0];

  const {
    consultaCarcerarioNominal,
    resultadoCarcerarioNominal,
    mensagemCarcerario,
    limparConsultaCarcerarioNominal,
  } = carcerarioStoreNominal((state) => state.carcerario);
  const { loading } = carcerarioStoreNominal((state) => state.global);

  const pesquisaCarcerarioNominal = (data: InputProps) => {
    consultaCarcerarioNominal(
      url,
      data.nome === "" ? undefined : data.nome,
      data.vulgo === "" ? undefined : data.vulgo,
      data.nomeMae === "" ? undefined : data.nomeMae,
      data.nomePai === "" ? undefined : data.nomePai
    );
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  return (
    <LayoutConsultaCarcerario>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(pesquisaCarcerarioNominal)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nome"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="vulgo"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o vulgo"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nomeMae"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome da mãe"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nomePai"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome do pai"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaCarcerarioNominal}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoCarcerarioNominal || mensagemCarcerario ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoCarcerarioNominal &&
            resultadoCarcerarioNominal?.map((cidadao) => (
              <ResultadoConsultaCarcerario
                key={cidadao.DET_ID}
                situacao={cidadao.SITUACAO}
                infoNome={cidadao.DET_NOME}
                vulgo={cidadao.DET_NOMEVULGO}
                infoMae={cidadao.DET_NOMEMAE}
                infoPai={cidadao.DET_NOMEPAI}
                to={`consulta-carcerario/ficha-carcerario/${cidadao.DET_ID}`}
              />
            ))) || (
            <MUI.Typography variant="h6">{mensagemCarcerario}</MUI.Typography>
          )
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaCarcerario>
  );
};
